export const theme = {
  red: "rgb(229, 7, 20)",
  black: {
    veryDark: "#141414",
    darker: "#181818",
    lighter: "#2F2F2F",
  },
  white: {
    lighter: "#fff",
    darker: "#e5e5e5",
  },
};

export const lightTheme = {};
